import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import ApprovalDetails from './approval_details';

import './styles.scss';

export default class VoucherApprovalStatusOverlayTrigger extends React.Component {
  static propTypes = {
    approvalWorkflow: PropTypes.object.isRequired,
    completedApprovalTasks: PropTypes.array.isRequired,
    uncompletedApprovalTasks: PropTypes.array.isRequired,
    voucherId: PropTypes.number,
  }

  render() {
    if (this.props.uncompletedApprovalTasks.length === 0) {
      return null;
    }

    const tooltip = (
      <Popover
        className="voucher-approval-status-popover"
        id={`voucher-${this.props.voucherId}-approval-status-popover`}
      >
        <ApprovalDetails
          approvalWorkflow={this.props.approvalWorkflow}
          completedApprovalTasks={this.props.completedApprovalTasks}
          uncompletedApprovalTasks={this.props.uncompletedApprovalTasks}
        />
      </Popover>
    );

    return (
      <OverlayTrigger overlay={tooltip} placement="bottom">
        <FontAwesomeIcon className="ml-2" icon={faInfoCircle} size="lg" />
      </OverlayTrigger>
    );
  }
}
